import request from './request.js'
import utils from './utils.js'
let publics = {

    authPasswordLogin(_data) { //员工登录接口
        return request({
            url: '/system/login/authPasswordLogin?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },

    uploadList(_data) { //文件上传
        return request({
            url: '/system/upload/uploadList',
            method: 'post',
            data: _data,
        })
    },

    getDataStatistics(_data) { //数据统计
        return request({
            url: '/system/dataStatistics/getDataStatistics?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
};
let user = {
    ZinitAccountPage(_data) { //用户列表
        return request({
            url: '/system/account/initAccountPage?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    exportUserListTemplate(_data) { //导出用户列表
        return request({
            url: '/system/account/exportUserListTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob'
        })
    },

    ZuserStatistics(_data) { //用户管理统计
        return request({
            url: '/system/account/userStatistics?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    ZgetUserBaseInfoForShop(_data) { //获取用户详情
        return request({
            url: '/system/account/getUserBaseInfoForShop?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    ZgetUserModelingData(_data) { //获取用户建模数据
        return request({
            url: '/system/account/getUserModelingData?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    saveCalibrationMeasureInfoV2(_data) { //保存建模数据
        return request({
            url: '/system/account/saveCalibrationMeasureInfoV2?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    freezeAndRecovery(_data) { //获取用户详情
        return request({
            url: '/system/account/freezeAndRecovery?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },

    ZgetUserRelativesFriendsList(_data) { //用户亲友列表
        return request({
            url: '/system/account/getUserRelativesFriendsList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    ZgetUserTargetSettings(_data) { //用户控糖目标
        return request({
            url: '/system/account/getUserTargetSettings?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    ZgetUserTimeSlotList(_data) { //用户时段设置
        return request({
            url: '/system/account/getUserTimeSlotList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    ZgetUserBloodGlucoseWarning(_data) { //用户血糖预警
        return request({
            url: '/system/account/getUserBloodGlucoseWarning?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },


    ZgetSugarTestingPlanSwitch(_data) { //用户查询测糖计划开关
        return request({
            url: '/system/account/getSugarTestingPlanSwitch?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    ZgetSugarTestingPlanCycleList(_data) { //用户查询测糖计划周期列表
        return request({
            url: '/system/account/getSugarTestingPlanCycleList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },


    healthRecordsList(_data) { //用户健康记录
        return request({
            url: '/system/account/healthRecordsList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    dailyBloodDataInfo(_data) { //每日血糖数据
        return request({
            url: '/system/account/dailyBloodDataInfo?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    bloodDataInfoStatistics(_data) { //血糖数据统计
        return request({
            url: '/system/account/bloodDataInfoStatistics?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    bloodDataInfoRecord(_data) { //血糖数据记录
        return request({
            url: '/system/account/bloodDataInfoRecord?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    exportBloodDataInfoRecordTemplate(_data) { //导出用户列表
        return request({
            url: '/system/account/exportBloodDataInfoRecordTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob'
        })
    },

    messageList(_data) { //消息列表
        return request({
            url: '/api/gkMssage/messageList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    insert(_data, html) { //添加消息
        return request({
            url: '/api/gkMssage/insert?data=' + JSON.stringify(_data),
            method: 'post',
            data: {
                content: html,
            },
        })
    },
    delete(_data) { //删除消息
        return request({
            url: '/api/gkMssage/delete?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
};
let finance = {
    financeList(_data) { //财务明细列表
        return request({
            url: '/api/finance/financeList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    exportFinanceListTemplate(_data) {
        //导出财务列表
        return request({
            url: '/api/finance/exportFinanceListTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },
};
let orderReport = {
    getUserBloodReportList(_data) { //血糖报告订单列表
        return request({
            url: '/api/report/getUserBloodReportList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    bloodReportOrderDetail(_data) { //血糖报告订单详情
        return request({
            url: '/api/report/bloodReportOrderDetail?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    // 预警管理
    bloodWarningList(_data) { //血糖预警
        return request({
            url: '/api/gkMssage/bloodWarningList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

};
let warning = {
    // financeList(_data) {  //血糖明细列表
    //     return request({
    //         url: '/api/finance/financeList?data=' + JSON.stringify(_data),
    //         method: 'get',
    //     })
    // },

    // exportFinanceListTemplate(_data) {
    //     //导出财务列表
    //     return request({
    //       url:
    //         '/api/finance/exportFinanceListTemplate?data=' + JSON.stringify(_data),
    //       method: 'get',
    //       responseType: 'blob',
    //     });
    //   },
};
let channel = {
    providerList(_data) { //渠道商列表
        return request({
            url: '/api/provider/providerList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    exportProviderListTemplate(_data) {
        //导出财务列表
        return request({
            url:
                '/api/provider/exportProviderListTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },

    accountExportBloodDataInfoRecordTemplate(_data) {
        //导出血糖数据记录
        return request({
            url:
                '/api/thermometryLog/exportTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },

    thermometryLogList(_data) { //测温记录列表
        return request({
            url:
                '/api/thermometryLog/thermometryLogList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    providerDetail(_data) { //渠道商详情
        return request({
            url: '/api/provider/providerDetail?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    insertAndUpdateProvider(_data) { //添加|编辑渠道商
        return request({
            url: '/api/provider/insertAndUpdateProvider?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },

    freezeProviderAndRecovery(_data) { //渠道商冻结|恢复
        return request({
            url: '/api/provider/freezeProviderAndRecovery?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    providerUserList(_data) { //渠道商会员
        return request({
            url: '/api/provider/providerUserList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    secondaryProviderList(_data) { //二级渠道商列表
        return request({
            url: '/api/provider/secondaryProviderList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
};
let device = {

    deviceList(_data) { //设备列表
        return request({
            url: '/api/device/deviceList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    deviceBindingList(_data) { //设备绑定记录列表
        return request({
            url: '/api/device/deviceBindingList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    exportTemplate(_data) {
        //导出设备模板
        return request({
            url: '/api/device/exportTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },
    deviceDetail(_data) { //设备详情
        return request({
            url: '/api/device/deviceDetail?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    updateDeviceStatus(_data) { //设备更改状态
        return request({
            url: '/api/device/updateDeviceStatus?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },

    orderDeviceList(_data) { //设备订单列表
        return request({
            url: '/api/orderDevice/orderDeviceList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    exportOrderDeviceListTemplate(_data) {
        //导出设备订单
        return request({
            url: '/api/orderDevice/exportOrderDeviceListTemplate?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },
    orderDeviceDetailDeviceList(_data) { //订单下的设备列表
        return request({
            url: '/api/orderDevice/orderDeviceDetailDeviceList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    orderDeviceDetail(_data) { //设备订单详情
        return request({
            url: '/api/orderDevice/orderDeviceDetail?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    insertProviderDeviceOrder(_data) { //添加渠道商订单
        return request({
            url: '/api/orderDevice/insertProviderDeviceOrder?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    importDevice(_data) { //添加渠道商订单
        return request({
            url: '/api/device/importDevice?data=' + JSON.stringify(_data),
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob',
        })
    },
}
let text = {
    ZguideList(_data) { //指南列表
        return request({
            url: '/system/news/guideList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    ZguideDetail(_data) { //指南详情
        return request({
            url: '/system/news/guideDetail?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    ZinsertGuide(_data, data) { //添加指南
        return request({
            url: '/system/news/insertGuide?data=' + JSON.stringify(_data),
            method: 'post',
            data,
        });
    },

    ZdeleteGuide(_data) { //删除指南 
        return request({
            url: '/system/news/deleteGuide?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    ZcategoryInsert(_data) { //添加知识分类 
        return request({
            url: '/system/news/categoryInsert?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    ZcategoryList(_data) { //知识分类列表 
        return request({
            url: '/system/news/categoryList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    deleteCategory(_data) { //删除知识分类
        return request({
            url: '/system/news/deleteCategory?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    deleteNews(_data) { //删除知识
        return request({
            url: '/system/news/deleteNews?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    ZnewsList(_data) { //获取知识列表 
        return request({
            url: '/system/news/newsList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    ZnewsDetail(_data) { //获取知识详情
        return request({
            url: '/system/news/newsDetail?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    ZinsertNews(_data, data) { //添加修改知识
        return request({
            url: '/system/news/insertNews?data=' + JSON.stringify(_data),
            method: 'post',
            data
        });
    },
};
let install = {
    adminInfo(_data) { //账号基本信息
        return request({
            url: '/api/gkAdminCenter/adminInfo?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    adminList(_data) { //员工列表
        return request({
            url: '/api/gkAdminCenter/adminList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    gkAdminCenterinsert(_data) { //添加员工
        return request({
            url: '/api/gkAdminCenter/insert?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },

    gkAdminCenterupdate(_data) { //编辑员工
        return request({
            url: '/api/gkAdminCenter/update?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    gkAdminCenterdelete(_data) { //删除员工
        return request({
            url: '/api/gkAdminCenter/delete?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    roleList(_data) { //角色列表
        return request({
            url: '/api/gkAdminRole/roleList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    getMenuTree() {
        //获取所有菜单树
        return request({
            url: '/api/permission/getMenuTree',
            method: 'get',
        });
    },
    createRole(_data) {
        //添加角色
        return request({
            url: '/api/gkAdminRole/createRole?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    editRole(_data) {
        //编辑角色
        return request({
            url: '/api/gkAdminRole/editRole?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    removeRole(_data) {
        //删除角色
        return request({
            url: '/api/gkAdminRole/removeRole?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    distributionPermissionForRole(_data) {
        //分配角色权限
        return request({
            url: '/api/gkAdminRole/distributionPermissionForRole?data=' +
                JSON.stringify(_data),
            method: 'post',
        });
    },
    getBindingPermission(_data) {
        //获取角色已绑定权限
        return request({
            url: '/api/gkAdminRole/getBindingPermission?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    roleList(_data) {
        //身份列表初始化
        return request({
            url: '/api/gkAdminRole/roleList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    getAdminLogList(_data) {
        //操作日志列表
        return request({
            url: '/system/logger/getAdminLogList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    aboutUs() {
        //关于我们
        return request({
            url: '/system/aboutUs/aboutUs',
            method: 'get',
        });
    },

    updateAboutUs(_data) {
        //修改关于我们
        return request({
            url: '/system/aboutUs/updateAboutUs?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    feedbackList(_data) {
        // 问题反馈列表
        return request({
            url: '/api/feedbackAdmin/feedbackList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },
    deleteIds(_data) {
        // 删除问题反馈
        return request({
            url: '/api/feedbackAdmin/deleteIds?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

    articleDelete(_data) {
        //文章删除
        return request({
            url: '/system/article/articleDelete?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },

    articleInsertOrUpdate(_data, html) {
        //文章添加或更改
        return request({
            url: '/system/article/articleInsertOrUpdate?data=' + JSON.stringify(_data),
            method: 'post',
            data: html,
        });
    },

    articleList(_data) {
        //文章列表
        return request({
            url: '/system/article/articleList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },
    bannerList(_data) {
        //轮播图列表接口
        return request({
            url: '/system/banner/bannerList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },
    advertiseUpdate(_data, data) {
        //广告修改接口
        return request({
            url: '/system/banner/advertiseUpdate?data=' + JSON.stringify(_data),
            method: 'post',
            data: data,
        });
    },
    advertiseList(_data) {
        //广告列表接口
        return request({
            url: '/system/banner/advertiseList?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },
    bannerDelete(_data) {
        //轮播图删除接口
        return request({
            url: '/system/banner/bannerDelete?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    deleteLocalLifeBanner(_data) {
        //删除线下banner
        return request({
            url: '/system/banner/deleteLocalLifeBanner?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    bannerUpdate(_data, data) {
        //轮播图修改接口
        return request({
            url: '/system/banner/bannerUpdate?data=' + JSON.stringify(_data),
            data: data,
            method: 'post',
        });
    },
    appVersion(_data) {
        // 获取app的安卓/ios当前最新版本查询
        return request({
            url: '/api/gkAppVersion/appVersion?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },
    appVersionupdate(_data) {
        // 获取app的安卓/ios当前最新版本查询
        return request({
            url: '/api/gkAppVersion/update?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    menuList() {
        // 菜单列表（管理用）
        return request({
            url: '/api/permission/menuList',
            method: 'get',
        });
    },
    menuInsert(_data) {
        // 添加菜单
        return request({
            url: '/api/permission/menuInsert?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    menuUpdate(_data) {
        // 编辑菜单
        return request({
            url: '/api/permission/menuUpdate?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    menuDelete(_data) {
        // 删除菜单
        return request({
            url: '/api/permission/menuDelete?data=' + JSON.stringify(_data),
            method: 'post',
        });
    },
    accountOnlineCard(_data) {
        // 线上测量卡
        return request({
            url: '/system/account/onlineCard?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },
    accountOfflineCard(_data) {
        // 线下测量卡
        return request({
            url: '/system/account/offlineCard?data=' + JSON.stringify(_data),
            method: 'get',
        });
    },

};


let online = {
    onlineOnlineCardList(_data) { //线上卡列表
        return request({
            url: '/system/online/onlineCardList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    onlineTakeDown(_data) { //下架线上卡
        return request({
            url: '/system/online/takeDown?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    onlineDelete(_data) { //删除线上卡
        return request({
            url: '/system/online/delete?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    onlineDetail(_data) { //线上卡详情
        return request({
            url: '/system/online/detail?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    onlineCardList(_data) { //充值卡明细
        return request({
            url: '/system/online/cardList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    onlineExportCardList(_data) {
        //导出财务列表
        return request({
            url:
                '/system/online/exportCardList?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },
    cardOfflineBatchList(_data) { //线下卡批次列表
        return request({
            url: '/system/card/offlineBatchList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    cardInsertOfflineBatch(_data) { //添加充值卡批次
        return request({
            url: '/system/card/insertOfflineBatch?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    cardExpenseOfflineBatch(_data) { //作废充值卡批次
        return request({
            url: '/system/card/expenseOfflineBatch?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    cardOfflineBatchDetail(_data) { //充值卡批次详情
        return request({
            url: '/system/card/offlineBatchDetail?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    cardOfflineCardList(_data) { //充值卡明细
        return request({
            url: '/system/card/offlineCardList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    cardExportOfflineCardList(_data) {
        //导出充值卡明细
        return request({
            url:
                '/system/card/exportOfflineCardList?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        });
    },
    cardDeleteOfflineBatch(_data) { //删除充值卡批次
        return request({
            url: '/system/card/deleteOfflineBatch?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    accountLoseCard(_data) { //失效测量卡
        return request({
            url: '/system/account/loseCard?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    accountLoseCard(_data) { //失效测量卡
        return request({
            url: '/system/account/loseCard?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    deviceUpdateFreeStatus(_data) { //设备修改收费状态
        return request({
            url: '/api/device/updateFreeStatus?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    deviceUnbind(_data) { //解绑设备
        return request({
            url: '/api/device/unbind?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    deviceDeleteDevice(_data) { //删除设备
        return request({
            url: '/api/device/deleteDevice?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    deviceBindPartner(_data) { //绑定/解绑合作商
        return request({
            url: '/api/device/bindPartner?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },

};
let partner = {
    partnerAuthList(_data) { //合作商列表（下拉框用）
        return request({
            url: '/api/partner/authList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerMeasureList(_data) { //合作商测量数据列表
        return request({
            url: '/api/partner/measureList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerExportMeasureList(_data) { //导出合作商测量数据
        return request({
            url: '/api/partner/exportMeasureList?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        })
    },
    partnerAuthList(_data) { //合作商鉴权列表（用于下拉选择）
        return request({
            url: '/api/partner/authList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerHistoryList(_data) { //合作商用户历史测量数据（查 _his 表）
        return request({
            url: '/api/partner/historyList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerExportHistoryList(_data) { //导出合作商用户历史测量数据
        return request({
            url: '/api/partner/exportHistoryList?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        })
    },

    partnerManageList(_data) { //合作商管理列表（分页）
        return request({
            url: '/api/partner/partnerManageList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    partnerInsert(_data) { //新增合作商
        return request({
            url: '/api/partner/partnerInsert',
            method: 'post',
            data: { data: utils.Encrypt(JSON.stringify(_data)) }
        })
    },

    partnerUpdate(_data) { //编辑合作商
        return request({
            url: '/api/partner/partnerUpdate',
            method: 'post',
            data: { data: utils.Encrypt(JSON.stringify(_data)) }
        })
    },

    partnerDelete(_data) { //删除合作商
        return request({
            url: '/api/partner/partnerDelete?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    partnerSecret(_data) { //查看合作商密钥
        return request({
            url: '/api/partner/partnerSecret?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },

    // ===== 一代机用户 =====
    partnerFirstDeviceUserList(_data) { //一代机用户列表
        return request({
            url: '/api/partner/firstDeviceUserList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerFirstDeviceUserInfo(_data) { //一代机用户个人信息
        return request({
            url: '/api/partner/getFirstDeviceUserInfo?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerFirstDeviceInsulin(_data) { //一代机用户胰岛素
        return request({
            url: '/api/partner/getFirstDeviceInsulin?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerFirstDeviceCalibration(_data) { //一代机用户标定
        return request({
            url: '/api/partner/getFirstDeviceCalibration?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerFirstDeviceMeasureList(_data) { //一代机用户测量数据
        return request({
            url: '/api/partner/getFirstDeviceMeasureList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    partnerFirstDeviceUserExport(_data) { //导出一代机用户列表
        return request({
            url: '/api/partner/exportFirstDeviceUserList?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        })
    },
    partnerFirstDeviceMeasureExport(_data) { //导出一代机测量数据
        return request({
            url: '/api/partner/exportFirstDeviceMeasureList?data=' + JSON.stringify(_data),
            method: 'get',
            responseType: 'blob',
        })
    },
    pushLogList(_data) { //推送日志列表
        return request({
            url: '/api/pushLog/list?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    pushLogRetry(_data) { //重新推送
        return request({
            url: '/api/pushLog/retry?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    pushLogChildren(_data) { //查子重推记录
        return request({
            url: '/api/pushLog/children?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
};

let hebei = {
    ZhbMemberList(_data) { //会员列表
        return request({
            url: '/api/hbMember/memberList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    ZhbMemberInsert(_data) { //新增会员
        return request({
            url: '/api/hbMember/insert?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    ZhbMemberUpdate(_data) { //编辑会员
        return request({
            url: '/api/hbMember/update?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    ZhbMemberDelete(_data) { //删除会员
        return request({
            url: '/api/hbMember/delete?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    ZhbMemberBloodList(_data) { //会员血糖测量列表
        return request({
            url: '/api/hbMemberBlood/bloodList?data=' + JSON.stringify(_data),
            method: 'get',
        })
    },
    ZhbMemberBloodInsert(_data) { //新增血糖记录
        return request({
            url: '/api/hbMemberBlood/insert?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    ZhbMemberBloodUpdate(_data) { //编辑血糖记录
        return request({
            url: '/api/hbMemberBlood/update?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
    ZhbMemberBloodDelete(_data) { //删除血糖记录
        return request({
            url: '/api/hbMemberBlood/delete?data=' + JSON.stringify(_data),
            method: 'post',
        })
    },
};

export default {
    ...publics, //公共
    ...user, //用户
    ...finance, //财务
    ...text, //文本类
    ...install, //设置
    ...channel, //渠道商
    ...device, //设备/设备订单
    ...warning, //预警
    ...orderReport, //订单报告/预警管理
    ...online,//测量卡管理
    ...partner,//合作商
    ...hebei,//河北云端

}